import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastService } from '../../../core/services/toast.service';
import { EnvService } from 'src/app/core/helpers/env.service';
import { ProfileService } from 'src/app/views/profile/profile.service';
import { TranslateService } from '@ngx-translate/core';

export enum Status {
    OnEmail = 0,
    OnLink = 1,
}

@Component({
    selector: 'app-forgot-password-modal',
    templateUrl: './forgot-password-modal.component.html',
    styleUrls: ['./forgot-password-modal.component.scss'],
})
export class ForgotPasswordModalComponent implements OnInit {
    @Output() back = new EventEmitter<void>();
    @Output() closed = new EventEmitter<void>();
    @Output() showLogin = new EventEmitter<void>();

    email = '';
    status = Status.OnEmail;
    matchPassword = true;

    constructor(
        private profileService: ProfileService,
        private envService: EnvService,
        private toast: ToastService,
        private translate: TranslateService
    ) {}

    ngOnInit() {}

    showConfirmPassword = false;
    toggleConfirmPassword() {
        this.showConfirmPassword = !this.showConfirmPassword;
    }

    close() {
        // Đóng modal
    }

    goBack() {
        this.closed.emit();
        this.showLogin.emit();
    }

    sendCode() {
        if (!this.email) {
            return;
        }
        const body = {
            email: this.email,
            redirectUrl: `${this.envService.DOMAIN}/new-password`,
        };
        this.profileService.getLinkForgotPassword(body).subscribe(
            (val) => {
                if (val?.status) {
                    this.status = Status.OnLink;
                } else {
                    const errorMsg = this.translate.instant('notifications.forgotPassword.errorOccurred');
                    this.toast.error(errorMsg);
                }
            },
            () => {
                const errorMsg = this.translate.instant('notifications.forgotPassword.errorOccurred');
                this.toast.error(errorMsg);
            }
        );
    }
}
